import axios from "axios";
import React, { useState } from "react"
import { useEffect } from "react"
import { useCookies } from "react-cookie";
import * as Constants from '../../constants/urls';
import ItemList from "./ItemList"
import Pagination from "react-js-pagination";
import Header from "../Header/Header";
import { Drawer } from "@material-ui/core";
import RightMenu from "../RightMenu";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
export default function PackConflict() {

    const [data, setData] = useState([]);
    const [cookies, setCookie, removeCookie] = useCookies();
    const [state, setState] = React.useState({ right: false });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };
    async function check(e) {
        e.preventDefault();
        console.log(e.target.elements.stock.value);
    }


    async function getData(page = 1) {
        console.log(cookies.user_server_token);
        const url = Constants.apiUrl + "/api/conflict/pack?page=" + page;
        axios
            .get(url, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            })
            .then((r) => {
                setData(r.data);
                console.log("RR", r.data);
            })
            .catch((e) => {
                if (e.response.status == 403) {
                    window.location = "403";
                }
            });
    }

    useEffect(() => {
        getData(1);
    }, [])

    return (<>
                               <Breadcrumb title={"مغایرت بسته ها"} />

        <div className="container my-4">
            {
                data.data != undefined && data.data.map((item) => {
                    return (
                        <ItemList
                        key={`${item.id}-${data.current_page}`}
                         renew={() => { getData(data.current_page) }} image={item.prodID} name={item.productName} packs={item.packs} productId={item.id} />
                    )
                })
            }
            {data != undefined && <Pagination
                totalItemsCount={data.total}
                activePage={data.current_page}
                itemsCountPerPage={data.per_page}
                onChange={(number) => {
                    getData(number);
                }}
                itemClass="page-item"
                linkClass="page-link"
                firstPageText="اولین صفحه"
                lastPageText="آخرین صفحه"
                nextPageText="بعدی"
                prevPageText="قبلی"
                activeClass="pageactive"
            />}
        </div>

    </>)
}